            
<template>  
  <div>
    <div class="modalsave" v-show="saveConfig.capa"></div>
    <div v-if="retirosInc.length>0">
      <h6>Lista de afiliados con incapacidades pendientes y que se van a retirar.</h6>
      <table  style="margin-bottom:0" class="table table--get table-hover border box-effect linear">
        <thead>
          <tr>
            <th>Documento</th>
            <th>Nombres</th>
            <th>Quitar del plano</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(items,index) in retirosInc" :key="'listadoInc'+index">
            <td>{{items.documento}}</td>
            <td>{{items.name}}</td>            
            <td>     
              <div style="display:inline-block;padding-left:5px;padding-right:5px">
                <b-icon  @click="spliceafiliadosAporte(index,items.indexSave,items.id)"  class="option-btn" icon="trash" scale="1.7" variant="danger"></b-icon>
              </div>
            </td>
          </tr>
        </tbody>
      </table> 
      <b-button v-if="!getArchivo" variant="primary"  :disabled="invalid" size="sm" @click="retirosInc=[]" style="margin-top:20px;float:right">Continuar</b-button>       
    </div>
    <div v-if="(ccfs>0 || retiros) && retirosInc.length===0">
      <validation-observer v-slot="{ invalid }">
        <p v-if="ccfs>0">hay {{ccfs}} afiliado(s) sin CCF asignele la CCF y el salario para generar el archivo plano</p>
        <b-form   inline style="margin-bottom:15px" novalidate >
          <sw-inputs 
            v-if="ccfs>0"
            :md="12"
            :lg="12"
            inputTabla="archivo_plano"
            inputCampo="id_list_ccf"
            inline>
          </sw-inputs>
          <sw-inputs
            v-if="ccfs>0"
            :md="12"
            :lg="12"
            inputTabla="archivo_plano"
            inputCampo="ibcccf"
            inline>
          </sw-inputs>
          <sw-inputs
            style="margin-top: 20px;"
            v-if="retiros"
            :md="12"
            :lg="12"
            inputTabla="archivo_plano"
            inputCampo="dias"
            inline>
          </sw-inputs>
          <b-col>
            <b-button v-if="!getArchivo"  :disabled="invalid" size="sm" @click="archivoGenerar()" style="margin-top:20px;float:right">Generar Archivo</b-button>
            <b-button  
              v-if="getArchivo" 
              disabled 
              style="margin-top:20px;float:right" 
              size="sm"
              class="ml-2 sw-save-loading"  
              ><div> <b-spinner variant="light" label="Spinning"></b-spinner></div>Generar Archivo</b-button>
          </b-col>
        </b-form>
      </validation-observer>
    </div>
    <div v-else-if="retirosInc.length===0">
      <validation-observer v-slot="{ invalid }">      
      <b-form inline style="margin-bottom:15px;padding-left:10px;padding-right:10px;" novalidate > 
              <validation-provider rules="required" immediate  v-slot="{ errors, required }"
                name="valor" style="position:relative;width:100%">         
                <b-input-group size="md" prepend="Valor de planilla" >
                  <vue-numeric 
                    separator="."   
                    class="form-control"       
                    :empty-value="0" 
                    v-model="registroPlanilla.aporte"
                    :precision="0">
                  </vue-numeric>   
                </b-input-group> 
              </validation-provider>
              <br>
              <validation-provider rules="required" immediate  v-slot="{ errors, required }"
                name="planilla" style="position:relative;width:100%">         
                <b-input-group size="md" prepend="No de planilla" >
                  <b-form-input  v-model="registroPlanilla.planilla" ></b-form-input>
                </b-input-group> 
              </validation-provider>
              <br>
              <br>
              <br>
              <validation-provider immediate  v-slot="{ errors, required }"
                name="fechaplanilla" style="position:relative;width:100%">  
                <b-input-group size="md" prepend="Fecha de pago" >
                <input type="date" style="flex: auto;" v-model="registroPlanilla.fechaplanilla">
                </b-input-group> 
              </validation-provider>
      </b-form>        
      <footer id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
            <sw-saveform
              :index="dataIndex[namePath]"
              nameBtn="Registro de planilla"
              :invalid="invalid"
              @save="save"
              >
            </sw-saveform>
      </footer>
    </validation-observer>
    </div>
  </div> 
</template>
<script>
import { mapState, mapActions } from "vuex"
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import { ValidationProvider } from 'vee-validate'
import VueNumeric   from '@/components/vue-numeric/vue-numeric.vue'
import moment from 'moment'
export default 
{
  name: 'swmodalasesores',
  components: {
    SwInputs,
    SwSaveform,
    ValidationProvider,
    VueNumeric,
  },
  props: {
    nameInactive: {
      type: String,
      default: ''
    },
    prioridad: {
      type: Boolean,
      default: false
    }
  },
  data()
  {
    return {
      registroPlanilla: {
        planilla: null,
        fechaplanilla: null,
        aporte: 0,
      },
      ccfs: 0,
      retiros: false,
      getArchivo: false,
      retirosInc: []
    }
  },
  async created()
  {
    if(this.namePath==='archivo_aportes')
    {
      await this.initArchivo_aportes()  
      this.registroPlanilla.fechaplanilla=this.fecha().fecha.minHoy
      this.retiros=false
    }
    if(this.namePath==='archivo_retiros')
    {
      await this.updateDataForm({state: 'base', data: await this.buscarIdb({tabla:'base', campo: 'id', value: 1})})
      await this.initArchivo_retiros()        
      this.registroPlanilla.fechaplanilla=this.fecha().fecha.minHoy
      this.retiros=true
    }
    
    await this.updateGlobal({state:'openModal/modal/loaded',data:true})
  },
  async destroyed(){
  },
  methods: {
		...mapActions({			
			saveData: 'crudStore/saveData',
    }),  
    initArchivo_retiros()
    {
      let seleccionados=this.tableSave.tableGetRetiros.btn0
      let ids = []
      this.ccfs=0
      for (let i = 0; i < seleccionados.length; i++) {
        if(seleccionados[i].check)
        {
          if(_.findIndex(this.dataGet[this.namePath].data[seleccionados[i].index].servicios_activos, {'name': 'Ccf','nota_delete':null})===-1)
          {
            this.ccfs=this.ccfs+1
          }
          if(this.dataGet[this.namePath].data[seleccionados[i].index].info_incapacidades)
          {
              this.retirosInc.push({indexSave:i,name: this.dataGet[this.namePath].data[seleccionados[i].index].datos_afiliado.name, documento: this.dataGet[this.namePath].data[seleccionados[i].index].datos_afiliado.documento, id: this.dataGet[this.namePath].data[seleccionados[i].index].datos_afiliado.id})  
          }
        }
      }
    } ,
    initArchivo_aportes()
    {
      let seleccionados=this.tableSave.tableGetArchivo.btn0
      let ids = []
      this.ccfs=0
      for (let i = 0; i < seleccionados.length; i++) {
        if(seleccionados[i].check)
        {
          this.registroPlanilla.aporte=this.registroPlanilla.aporte+seleccionados[i].archivo_plano.aporte
          if(seleccionados[i].archivo_plano.tipo==1 && seleccionados[i].archivo_plano.codigoccf==null)
          {
            this.ccfs=this.ccfs+1
          }
          if(seleccionados[i].archivo_plano.id_list_novedad===3 && this.dataGet[this.namePath].data[seleccionados[i].index].info_incapacidades)
          {
              this.retirosInc.push({indexSave:i,name: this.gettersDatalist('datos_afiliado',this.dataGet[this.namePath].data[seleccionados[i].index].archivo_plano.id_datos_afiliado)[0].name, documento: this.dataGet[this.namePath].data[seleccionados[i].index].archivo_plano.documento, id: this.dataGet[this.namePath].data[seleccionados[i].index].archivo_plano.id})  
          }
        }
      }
      return true
    },
    async spliceafiliadosAporte(index,indexSave,idArchivo)
    {
      this.retirosInc.splice(index,1)
      if(this.namePath==='archivo_aportes')
      {
        let indexArchivo_plano=this.dataForm[this.namePath].archivo_plano.findIndex(list => list.id.toString()===idArchivo.toString())
        if(indexArchivo_plano.length!==-1)
        {
          await this.spliceDataForm({state: 'archivo_plano', index: indexArchivo_plano}) 
        }
        this.updateCrud({ state: 'tableSave/tableGetArchivo/btn0/'+indexSave+'/check', data: false})
        await this.initArchivo_aportes()
        if(this.dataForm[this.namePath].archivo_plano.length===0)
        {
          await this.resetGlobal({state:'openModal'})
        }
      }      
      if(this.namePath==='archivo_retiros')
      {       
        this.updateCrud({ state: 'tableSave/tableGetRetiros/btn0/'+indexSave+'/check', data: false})
        await this.initArchivo_retiros()
        if(this.tableSave.tableGetRetiros.btn0.filter(list => list.check).length===0)
        {
          await this.resetGlobal({state:'openModal'})
        }
      }     
      return true
    },
    async archivoGenerar(cor = false)
    {      
      this.getArchivo=true
      if(this.namePath==='archivo_aportes')
      {
        let seleccionados=this.tableSave.tableGetArchivo.btn0
        let ids = []
        for (let i = 0; i < seleccionados.length; i++) {
          if(seleccionados[i].check)
          {
            ids.push(seleccionados[i].archivo_plano.id)	
          }
        }
        let codigoccf=this.gettersDatalist('list_ccf',this.dataForm[this.namePath].archivo_plano.id_list_ccf)[0].codigo
        window.open( this.url+'/api/pdf/archivoPlano?mes='+this.openModal.modal.mes+'&ano='+this.openModal.modal.ano+'&razon='+this.openModal.modal.razon+'&list='+ids.toString()+'&codigoccf='+codigoccf+'&ibcccf='+this.dataForm[this.namePath].archivo_plano.ibcccf+'&planilla='+this.registroPlanilla.planilla+'&cor='+cor+'&prio='+this.prioridad+'&token='+this.token)
      }         
      if(this.namePath==='archivo_retiros')
      {
        let claseriesgo=1
        let ibc= { Afp: null, Ccf: null, Eps: null,  Riesgo: null, }
        let tarifa={  Afp: null, Eps: null, Riesgo: null, Ccf: null, }
        let cotizacion= { Afp: null, Eps: null, Riesgo: null, Ccf: null, }
        let codigo= { Ccf: null, Afp: null, Eps: null, }
        let dataArchivoPlano = []
        let seleccionados=this.tableSave.tableGetRetiros.btn0
        for (let i = 0; i < seleccionados.length; i++) { 
          ibc= { Afp: null, Ccf: null, Eps: null,  Riesgo: null, }
          tarifa={  Afp: null, Eps: null, Riesgo: null, Ccf: null, }
          cotizacion= { Afp: null, Eps: null, Riesgo: null, Ccf: null, }
          codigo= { Ccf: null, Afp: null, Eps: null, }
          if(seleccionados[i].check)
          {
            let dataRetiro = this.deepCopy(this.dataGet[this.namePath].data[seleccionados[i].index])

            let mesPeriodo=parseInt(dataRetiro.info_afiliacion.mes_periodo)
            let anoPeriodo=parseInt(dataRetiro.info_afiliacion.ano_periodo)
            let diasAportes=this.dataForm[this.namePath].archivo_plano.dias
            let novedadAportes=3   
            dataRetiro.info_afiliacion.id_list_novedad=3     

            let fechaArchivo=this.fecha().fecha.minHoy

            let ingresoPlano=null
            let fechaingresoPlano=null
           
            let retiroPlano='X'
            let fecharetiroPlano=moment(this.fecha().fecha.retPrimero).add(diasAportes-1, 'days');
            fecharetiroPlano=moment(fecharetiroPlano).format('YYYY-MM-DD')
            
            let fecha11=moment(dataRetiro.info_afiliacion.ingreso)
            let fecha21=moment(this.fecha().fecha.retPrimero)
            let mes_ingreso=parseInt(moment(dataRetiro.info_afiliacion.ingreso).format('MM'))
            let mes_retiro=parseInt(moment(this.fecha().fecha.retPrimero).format('MM'))
            let dias1=parseInt(fecha21.diff(fecha11, 'months'))

            if(dias1===0 && mes_retiro===mes_ingreso)
            {
              let dia_ingreso=parseInt(moment(dataRetiro.info_afiliacion.ingreso).format('DD'))
              if(dia_ingreso+diasAportes>30)
              {
                diasAportes=diasAportes-(dia_ingreso+diasAportes-31)
                fecharetiroPlano=this.fecha().fecha.retUltimo
              }
              else 
              {
                fecharetiroPlano=moment(dataRetiro.info_afiliacion.ingreso).add(diasAportes-1, 'days');
                fecharetiroPlano=moment(fecharetiroPlano).format('YYYY-MM-DD')
              }
              ingresoPlano='X'
              fechaingresoPlano=dataRetiro.info_afiliacion.ingreso
            }  
            
            dataRetiro.info_afiliacion.dias=diasAportes  
            dataRetiro.info_afiliacion.retiro=fecharetiroPlano             
          
            let diaspensionPlano=0
            let subtipo=dataRetiro.info_afiliacion.id_list_subtipo
            if(subtipo===1)
            {
              diaspensionPlano=diasAportes
            }            

            let exonerado='N'
            if(dataRetiro.info_afiliacion.exonerado===1)
            {
              exonerado='S'
            }  

            let nuevosActivos=this.deepCopy(dataRetiro.servicios_activos)
            let nuevoValor=0
            let nameServicios=[]
            for (let j = 0; j < nuevosActivos.length; j++) 
            { 
              if(nuevosActivos[j].name!=='Administración' && nuevosActivos[j].name!=='Traslado')
              {
                nameServicios.push(nuevosActivos[j])
              }
              dataRetiro.servicios_activos[j].retiro=fecharetiroPlano
              if(nuevosActivos[j].name==='Eps' || nuevosActivos[j].name==='Ccf' || nuevosActivos[j].name==='Afp'  )
              {
                let nameLista = await this.gettersDatalist(nuevosActivos[j].name_list,nuevosActivos[j].id_list)[0]

                codigo[nuevosActivos[j].name]=nameLista.codigo
                ibc[nuevosActivos[j].name]=parseInt((dataRetiro.info_afiliacion.salario/30)*diasAportes)
                if(nuevosActivos[j].name==='Eps')
                {
                  if(dataRetiro.info_afiliacion.exonerado===1)
                  { 
                    tarifa.Eps=this.dataForm[this.namePath].base[0].epsexo
                  }
                  else {
                    tarifa.Eps=this.dataForm[this.namePath].base[0].epsnoexo
                  }
                  cotizacion.Eps=this.redondeaValue(100,ibc.Eps*(tarifa.Eps/100),1)+ibc.Eps*(tarifa.Eps/100)
                }
                
                if(nuevosActivos[j].name==='Afp')
                {                
                  tarifa.Afp=this.dataForm[this.namePath].base[0].afp
                  cotizacion.Afp=this.redondeaValue(100,ibc.Afp*(tarifa.Afp/100),1)+ibc.Afp*(tarifa.Afp/100)
                }

                if(nuevosActivos[j].name==='Ccf')
                {                
                  let razonData= this.gettersDatalist('datos_razon',dataRetiro.info_afiliacion.id_datos_razon)[0]  
                  if(novedadAportes==3 && razonData.retiroparafiscales===1)
                  {
                    if(nuevosActivos[j].iniciolabores===null)
                    {
                      nuevosActivos[j].iniciolabores=dataRetiro.info_afiliacion.ingreso
                    }
                    let fecha1=moment(nuevosActivos[j].iniciolabores)
                    let fecha2=moment(fecharetiroPlano)
                    let dias=fecha2.diff(fecha1,'days')+1
                    if(dias<1) { dias=1;}
                    ibc.Ccf=ibc.Ccf+parseInt(dataRetiro.info_afiliacion.salariobase*dias/720)
                  }
                  tarifa.Ccf=this.dataForm[this.namePath].base[0].ccf
                  cotizacion.Ccf=this.redondeaValue(100,ibc.Ccf*(tarifa.Ccf/100),1)+ibc.Ccf*(tarifa.Ccf/100)
                }                
              }
              if(nuevosActivos[j].name==='Riesgo')
              {
                let nameLista = await this.gettersDatalist(nuevosActivos[j].name_list,nuevosActivos[j].id_list)[0] 
                codigo.Riesgo=nameLista.codigo
                ibc.Riesgo=parseInt((dataRetiro.info_afiliacion.salario/30)*diasAportes)
                claseriesgo=nuevosActivos[j].id_list
                tarifa.Riesgo=this.dataForm[this.namePath].base[0]['r'+nuevosActivos[j].id_list]
                cotizacion.Riesgo=this.redondeaValue(100,ibc.Riesgo*(tarifa.Riesgo/100),1)+ibc.Riesgo*(tarifa.Riesgo/100)
              }                         
            }
            
            dataArchivoPlano.push({ tipodocumento: this.gettersDatalist('list_documento',dataRetiro.datos_afiliado.id_list_documento)[0].name, documento: dataRetiro.datos_afiliado.documento, nombre1: dataRetiro.datos_afiliado.nombre1, nombre2: dataRetiro.datos_afiliado.nombre2, apellido1: dataRetiro.datos_afiliado.apellido1, apellido2: dataRetiro.datos_afiliado.apellido2, tipo:  this.gettersDatalist('list_tipo',dataRetiro.info_afiliacion.id_list_tipo)[0].codigo, subtipo: this.gettersDatalist('list_subtipo',subtipo)[0].codigo, horas: 0, extranjero: null, colextranjero: null, fechaextranjero: null,codigoccf: codigo.Ccf, codigoafp: codigo.Afp,codigoeps: codigo.Eps, diasafp: diaspensionPlano, diaseps: diasAportes, diasriesgo: diasAportes,diasccf: diasAportes, diasparafiscales: null, salario: dataRetiro.info_afiliacion.salario, salariointegral: null, ibcafp: ibc.Afp, ibceps: ibc.Eps, ibcriesgo: ibc.Riesgo, ibcccf: ibc.Ccf, ibcparafiscales: null, tarifaafp: tarifa.Afp, tarifaaltoriesgo: null, cotizacionafp: cotizacion.Afp, voluntariaaportante: null, voluntariaafiliado: null, totalafp: null, solidaridadafp: null, subsistencia: null, retenido: null, tarifaeps: tarifa.Eps, cotizacioneps: cotizacion.Eps, incapacidadeg: null, valoreg: null, licencia: null, valorlicencia: null, valorupc: null, tarifariesgo: tarifa.Riesgo, claseriesgo: claseriesgo, centrotrabajo: null, cotizacionriesgo: cotizacion.Riesgo, epsdestino: null, afpdestino: null, tarifasena: null, cotizacionsena: null, tarifaicbf: null, cotizacionicbf: null, tarifaccf: tarifa.Ccf, cotizacionccf: cotizacion.Ccf, tarifaesap: null, cotizacionesap: null, tarifamen: null, cotizacionmen: null, exonerado: exonerado, ingreso: ingresoPlano, fechaingreso: fechaingresoPlano, retiro: retiroPlano, fecharetiro: fecharetiroPlano, tda: null, taa: null, vsp: null, iniciovsp: null, vst: null, sln: null, iniciosln: null, finsln: null, ige: null, inicioige: null, finige: null, lma: null, iniciolma: null, finlma: null, vaclr: null, iniciovaclr: null, finvaclr: null, avp: null, vct: null, iniciovct: null, finvct: null, vip: null, corecciones: null, irl: null, inicioirl: null, finirl: null, dias: diasAportes,id_list_mes: mesPeriodo, id_list_ano: anoPeriodo})    
            
            
            dataRetiro.aportes_registro= {id:null,id_datos_afiliado: dataRetiro.datos_afiliado.id, id_datos_razon: dataRetiro.info_afiliacion.id_datos_razon, id_datos_asesor: dataRetiro.info_afiliacion.id_datos_asesor,id_info_afiliacion: dataRetiro.info_afiliacion.id,id_info_aportes: 0, id_list_novedad: 3,fecha: this.fecha().fecha.minHoy,reporte:0,valor:0,comision:0, servicios: nameServicios,servicio:0,mes_periodo: mesPeriodo,ano_periodo:anoPeriodo}
            
            dataRetiro.datos_afiliado.id_list_estado=2 
            await this.updateDataGet({index: seleccionados[i].index,data: dataRetiro})           
        
          }
        }
        let codigoccf=this.gettersDatalist('list_ccf',this.dataForm[this.namePath].archivo_plano.id_list_ccf)[0].codigo
      
        let nameArchivo = await this.saveData({data: {list: dataArchivoPlano, mes: this.openModal.modal.data.mes, ano: this.openModal.modal.data.ano, razon: this.openModal.modal.data.razon, codigoccf: codigoccf, ibcccf: this.dataForm[this.namePath].archivo_plano.ibcccf}, route: 'archivoplanoretiros'})  
        
        window.open( this.url+'/api/pdf/archivoRetiros?name='+nameArchivo.data.archivo+'&token='+this.token)         
      }          
      this.ccfs=0
      this.retiros=false
      this.getArchivo=false  
    },
    async save(emit)
    {
      if(this.namePath==='archivo_aportes')
      {
        this.archivoGenerar(true)
        let archivo_plano=[]
        for (let i = 0; i < this.dataForm[this.namePath].archivo_plano.length; i++) 
        {
            this.dataForm[this.namePath].archivo_plano[i].planilla=this.registroPlanilla.planilla
            this.dataForm[this.namePath].archivo_plano[i].fechaplanilla=this.registroPlanilla.fechaplanilla
            archivo_plano.push(this.dataForm[this.namePath].archivo_plano[i])
        }
        await this.updateDataForm({state: 'archivo_plano', data: archivo_plano})
      }
      
      this.$emit('save', { save: emit.save, ftn: 'registrarPLanillaFtn'})
    },
  }
}
</script>
<style>
</style>